import React, { useState, useEffect } from 'react';
import Fnc from '../library/Functions'
import InlineFieldLoader from './InlineFieldLoader';

function PhoneInp(props) {

  const [loading, setLoading] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [phoneValue, setPhoneValue] = useState(props.phone || '');

  //const [, updateState] = React.useState();
  //const forceUpdate = React.useCallback(() => updateState({}), []);

  useEffect(() => {
    // Similar to componentDidMount and componentDidUpdate:
    //checkPhone(props.phone);

  }, [props.isLogged,props.iva, props.loadData]); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento

  function onBlur(e) {
    let val = e.target.value;
    checkPhone(val);
  }

  function onChange(e) {
    const val = e.target.value;

    // Un telefono puo contenere separatori comuni, ma mai lettere o altri
    // caratteri. Essendo un input controllato, un carattere non ammesso non
    // viene nemmeno inserito nel campo.
    if (!/^[0-9+()./\s-]*$/.test(val)) return;

    setPhoneValue(val);

    if (phoneVerified !== val) {
      setPhoneVerified(false);
      setShowError(false);
      setErrorMsg(null);
      props.callback(new Fnc.Ret(Fnc.EnmPhone.KO));
    }
  }

  function checkPhone(val) {

    if (props.required) {
      //è un campo obbligatorio?

      if (val && val.length > 0) {
        //non ho un valore vuoto

        if (phoneVerified !== val) {
          //non è un valore che ho già controllato
          setLoading(true);

          let valdPhone = Fnc.gValidatePhone(val, 'IT');
          Fnc.log("GOOGLE PHONE:", valdPhone, Fnc.LogLvl.DEBUG);

          //let valdPhone = Fnc.validatePhone(val);
          if (valdPhone.code === Fnc.EnmPhone.OK) {
            //telefono formalmente valido?
            setPhoneVerified(val);
            setShowError(false);
            setErrorMsg(null);
            props.callback(valdPhone);

          } else {
            //il telefono specificato è formalmente NON valido
            setPhoneVerified(null);
            setShowError(true);
            setErrorMsg(valdPhone.code.msg);
            props.callback(valdPhone);
          }
          setLoading(false);

        }

      } else {
        setShowError(true);
        setErrorMsg(Fnc.EnmPhone.EMPTY.msg);
        props.callback(new Fnc.Ret(Fnc.EnmPhone.EMPTY));
      }

    } else {
      setShowError(false);
      setErrorMsg(null);
      props.callback(new Fnc.Ret(Fnc.EnmPhone.OK, null));
    }

  }


  return (
    <>
      <input className={`form-control ${showError ? "iol-field--error" : ""}`} type="tel" inputMode="tel" autoComplete="tel" placeholder="Es. +39 02 1234567" aria-labelledby="phone" value={phoneValue} onChange={onChange} onBlur={onBlur} aria-invalid={showError}></input>
      <span className={`placeholder-text ${(showError === true) && "lblError"} `}>
        {props.required && <span className="checkout-required-marker" aria-hidden="true">*</span>} Telefono
      </span>
      <InlineFieldLoader visible={loading} label="Verifica telefono in corso" />
      {showError === true && <div className="iol-error-label">{errorMsg}</div>}
    </>
  );
}

export default PhoneInp;
